import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../vuex/store';

import { catchImport } from '@H/utils';

const subscriptions = import(/* webpackChunkName: "subscriptions-bundle" */ './subscriptions');
const widgets = import(/* webpackChunkName: "widgets-bundle" */ './widgets');
const enrollment = import(/* webpackChunkName: "enrolment-bundle" */ './enrollment');
const auth = import(/* webpackChunkName: "auth-bundle" */ './auth');
const marketing = import(/* webpackChunkName: "marketing-bundle" */ './marketing');

import SomethingsGoneWrong from '@C/SomethingsGoneWrong';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/error',
            name: 'fatal-error',
            component: SomethingsGoneWrong,
        }
    ]
});

widgets.then(wi => {
    router.addRoutes(wi.default);
}).catch(catchImport);

enrollment.then(en => {
    router.addRoutes(en.default);
}).catch(catchImport);

auth.then(au => {
    router.addRoutes(au.default);
}).catch(catchImport);

subscriptions.then(su => {
    router.addRoutes(su.default);
}).catch(catchImport);

marketing.then(ma => {
    router.addRoutes(ma.default);
}).catch(catchImport);

router.beforeEach((to, from, next) => {
    if (typeof to.params.flash != 'undefined') {
        store.dispatch('Flash/setFlash', to.params.flash);
    } else {
        store.dispatch('Flash/clearFlash');
    }
    next();
});

export default router;



// WEBPACK FOOTER //
// ./resources/assets/js/router/index.js